import { useEmailPreviewStore, type EmailPreviewPayload } from '../../stores/useEmailPreviewStore';

/**
 * Opens the in-app email preview modal (`<GlobalEmailPreviewModal>` at
 * the app root). Replaces the old blob-URL-in-new-tab behavior so every
 * "click to preview an email" surface now lands in the same modal.
 *
 * Accepts either an HTML body string OR a partial `GQLMessageItem`
 * (subject, fromAddress, toAddress, etc.). Callers with metadata (e.g.
 * the activity feed which has eAlert subjects in metadata JSON) should
 * pass the object form so the modal headlines the real subject.
 */
export const previewEmail = async (
  payload: string | EmailPreviewPayload,
  _isScheduled: boolean = false
): Promise<void> => {
  if (typeof payload === 'string') {
    if (!payload) return;
    useEmailPreviewStore.getState().open(payload);
    return;
  }
  if (!payload || (!payload.bodyHtml && !payload.body && !payload.subject)) return;
  useEmailPreviewStore.getState().open(payload);
};
